/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_14Inputs */



/**
* | output |
* | --- |
* | "Desktop & Web Application access" |
*
* @param {Signup_Feature_Pro_14Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_14 = /** @type {((inputs?: Signup_Feature_Pro_14Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_14Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "de") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desktop & Web Application access")
	return /** @type {LocalizedString} */ ("Desktop & Web Application access")
});